module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio72-1259e2ffb5d6936af4797c49f8f388c9.m4a";